"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _jsTools = require("@airportlabs/js-tools");
var _authType = require("./authType");
var AUTH_TYPE = (0, _authType.getAuthType)();
var redirectToLogin = function redirectToLogin() {
  var href = (0, _jsTools.appendParamsToUrl)((0, _jsTools.getEnv)("REACT_APP_LOGIN_URL"), {
    back: window.location.href,
    isRequired: AUTH_TYPE !== _authType.authTypes.NONE
  });
  _jsTools.authConsole.log("redirectToLogin", href);
  window.location.href = href;
};
var _default = exports["default"] = redirectToLogin;